import { setStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_KEYS, SUPERSTORE_STORAGE_ITEMS, getStorageJsonValue } from '../../utils/superStoreUtils';
import { BANNER_REFRESH_TIMEOUT, DELIVERY_METHOD_NAMES, NOTIFICATION_ACTIONS } from '../../constants';
import isNotificationsDebug from '../../utils/isNotificationsDebug';
import { markAs } from '../../api/persistentApi';
import { interactionMetaCreator, usageMetaCreator } from '../../utils/analytics/NotificationsUsageTrackers';
export const setHasNotificationInStorage = (notifications = []) => {
  const hasNotifications = notifications && notifications.length > 0;
  return setStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.PERSISTENT,
    storageItem: SUPERSTORE_STORAGE_ITEMS.HAS_BANNER_NOTIFICATIONS,
    value: hasNotifications
  });
};
export const setLastCheckedInStorage = () => {
  return setStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.PERSISTENT,
    storageItem: SUPERSTORE_STORAGE_ITEMS.LAST_CHECKED,
    value: Date.now()
  });
};
export const getLastCheckedFromStorage = () => {
  return getStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.PERSISTENT,
    storageItem: SUPERSTORE_STORAGE_ITEMS.LAST_CHECKED
  });
};
export const getHasBannerNotificationsFromStorage = () => {
  return getStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.PERSISTENT,
    storageItem: SUPERSTORE_STORAGE_ITEMS.HAS_BANNER_NOTIFICATIONS
  });
};
export const shouldCheckForNotifications = () => {
  return Promise.all([getHasBannerNotificationsFromStorage(), getLastCheckedFromStorage()]).then(([hasBannerNotifications, lastChecked]) => {
    const now = Date.now();
    const timeSinceLastChecked = now - (lastChecked || 0);
    return isNotificationsDebug() || !lastChecked || hasBannerNotifications || timeSinceLastChecked > BANNER_REFRESH_TIMEOUT;
  });
};
export const markBannerAsRead = notification => {
  return Promise.all([interactionMetaCreator(notification, DELIVERY_METHOD_NAMES.BANNER, NOTIFICATION_ACTIONS.MARKED_AS_READ), markAs({
    id: notification.id,
    deliveryMethod: DELIVERY_METHOD_NAMES.BANNER,
    action: NOTIFICATION_ACTIONS.MARKED_AS_READ
  })]).then(([actionSent, apiCallSent]) => {
    return {
      markedAsReadActionFired: !!actionSent,
      markedAsReadApiRequestSent: !!apiCallSent
    };
  });
};
export const markBannerCTAClicked = notification => {
  return Promise.all([usageMetaCreator(notification, DELIVERY_METHOD_NAMES.BANNER, NOTIFICATION_ACTIONS.CTA_CLICKED), markAs({
    id: notification.id,
    deliveryMethod: DELIVERY_METHOD_NAMES.BANNER,
    action: NOTIFICATION_ACTIONS.CTA_CLICKED
  })]).then(([actionSent, apiCallSent]) => {
    return {
      ctaClickedActionFired: !!actionSent,
      ctaClickedApiRequestSent: !!apiCallSent
    };
  });
};
export const setNotificationTypesInStorage = (types = []) => {
  return setStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.SIDEBAR_NOTIFICATION_TYPES,
    storageItem: SUPERSTORE_STORAGE_ITEMS.TYPES,
    value: types
  });
};
export const getNotificationTypesFromStorage = () => {
  return getStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.SIDEBAR_NOTIFICATION_TYPES,
    storageItem: SUPERSTORE_STORAGE_ITEMS.TYPES
  });
};